// FutureLab
import { ChatListDataInterface } from '../ChatListItemsMobile';
import { returnOneToOneChatUserDetails } from '../../../utilities/UserDetails';
import { UserDetailsListItem } from '../../../model';
import { LoggedInUserDetails } from '../../../reducers/index';
import { isSameUserId } from '../../../utilities/UserId';
import avatarPlaceholder from '../../../assets/image/avatar_placeholder.png';

import { Avatar, AvatarFallback, AvatarImage } from '../../ui/avatar';

interface ChatListItemImageProps {
	chatListItem: ChatListDataInterface;
	loggedInUserDetails: LoggedInUserDetails;
	userListProfilesDetails: UserDetailsListItem[];
}

export function ChatListItemImage(chatListItemImageProps: ChatListItemImageProps) {
	const { chatListItem, loggedInUserDetails, userListProfilesDetails } = chatListItemImageProps;
	const photoUrl = `${process.env.REACT_APP_PROFILE_PHOTOS_BASE_URL}${process.env.REACT_APP_PROFILE_PHOTOS_S3_BASE_URL}${process.env.REACT_APP_PROFILE_PHOTOS_S3_DIRECTORY_URL}`;
	const userProfileDetails = returnOneToOneChatUserDetails(
		chatListItem,
		loggedInUserDetails,
		userListProfilesDetails
	);

	const getGroupChatNameFromParticipantNameInitials = (): string => {
		const groupParticipantIds = chatListItem.participants.map((participant) => participant.userId);
		const userListProfilesFullDetails = userListProfilesDetails.filter((userListProfileDetails) =>
			groupParticipantIds.some((userId) => isSameUserId(userId, userListProfileDetails.id))
		);
		return userListProfilesFullDetails[0]?.firstname?.charAt(0);
	};

	const getGroupChatNameInitials = (): string => {
		const nameFromDb = chatListItem?.name?.trim()?.charAt(0);
		return nameFromDb ? nameFromDb : getGroupChatNameFromParticipantNameInitials();
	};

	return (
		<div className="shrink-0 p-0">
			{chatListItem.isGroupChat ? (
				<Avatar className="chat-list-image-holder rounded-md">
					<AvatarFallback className="rounded-md">
						{getGroupChatNameInitials()?.toLocaleUpperCase()}
					</AvatarFallback>
				</Avatar>
			) : !!userProfileDetails?.profile_photo ? (
				<img
					alt=""
					src={`${photoUrl}/${userProfileDetails?.id}/${userProfileDetails?.profile_photo}`}
					className="chat-list-image-holder object-cover"
					onError={({ currentTarget }) => {
						currentTarget.onerror = null;
						currentTarget.src = avatarPlaceholder;
					}}
				/>
			) : (
				<Avatar className="chat-list-image-holder rounded-md">
					<AvatarImage src={userProfileDetails?.profile_photo || undefined} />
					<AvatarFallback className="rounded-md">
						{userProfileDetails?.firstname?.charAt(0).toLocaleUpperCase() || '?'}
						{userProfileDetails?.lastname?.charAt(0).toLocaleUpperCase() ?? ''}
					</AvatarFallback>
				</Avatar>
			)}
		</div>
	);
}
